import React, {} from 'react';
const styles = {"page":"SitePage-module__page__rz6s9"};
/**
 * The landing page's frame: the full window width edge to edge (no browser margin), the main landmark holding the
 * page's sections, then the footer. Unlike `Screen`, it has no centered column; each section sets its own.
 */
export function SitePage({ footer, children }) {
    return (React.createElement("div", { className: styles.page, "data-naru-page": "site" },
        React.createElement("main", null, children),
        footer));
}
//# sourceMappingURL=SitePage.js.map